import { useMemo } from "react";
import { TOP_NAV } from "@/config/nav";
import { useServices } from "@/contexts/ServicesContext";
import { useSettings } from "@/contexts/SettingsContext";

// Derives the navbar's nav links from admin-editable settings (falling back to
// static defaults), and attaches the Services/Marketing dropdown items sourced
// live from the Services list. Shared by Navbar + MobileMenu.
export const useHeaderConfig = () => {
  const { services } = useServices();
  const settings = useSettings();

  const navLinks = settings.nav_links?.length ? settings.nav_links : TOP_NAV;

  const navStructure = useMemo(
    () =>
      navLinks.map((link) => {
        if (link.label === "Services") {
          return { ...link, dropdown: services.filter((s) => s.category === "development").map((s) => ({ label: s.title, path: `/services/${s.slug}` })) };
        }
        if (link.label === "Marketing") {
          return { ...link, dropdown: services.filter((s) => s.category === "marketing").map((s) => ({ label: s.title, path: `/services/${s.slug}` })) };
        }
        return link;
      }),
    [services, navLinks]
  );

  return { navStructure };
};
